import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useGetResourceTypesQuery,
  useNewResAssMutation,
} from "../../services/appln";

interface FormData {
  resourceTypeId: string;
  count: string;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
  bandobastId: string;
  timeslotId: string;
  locationId: string;
}

export default function NewResourceAssessment(props: Props) {
  const [createResourceAssessment, createResourceAssessmentParams] =
    useNewResAssMutation();

  const resourceTypeData = useGetResourceTypesQuery(undefined);
  const resourceTypeMap = new Map<string, string>();
  resourceTypeData.data?.data.forEach((element: any) => {
    resourceTypeMap.set(element.name, element.id);
  });

  const iv: FormData = {
    resourceTypeId: "",
    count: "",
  };

  const onCancelHandlerWrapper = () => {
    createResourceAssessmentParams.reset();
    props.onCancelHandler();
  };

  console.log(
    "NewResourceAssessment, createResourceAssessmentParams",
    createResourceAssessmentParams,
  );
  React.useEffect(() => {
    if (createResourceAssessmentParams.isSuccess) {
      props.onSubmitHandler(createResourceAssessmentParams.data.id);
    }
  }, [createResourceAssessmentParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.newResourceAssessment}
        </DialogTitle>
        {createResourceAssessmentParams.isError && (
          <ErrorMsg msg={strings.failedToCreateResourceAssessment} />
        )}
        {createResourceAssessmentParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.resourceTypeId) {
                errors.resourceTypeId = strings.resourceTypeMandatory;
              }
              if (!values.count) {
                errors.count = strings.countMandatory;
              } else {
                const countVal = parseInt(values.count);
                if (isNaN(countVal)) {
                  errors.count = strings.countShouldBeNumber;
                }
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const valuesClone = { ...values };
              valuesClone.resourceTypeId = resourceTypeMap.get(
                values.resourceTypeId!,
              )!;
              setSubmitting(false);
              createResourceAssessment({
                bandobastId: props.bandobastId,
                timeslotId: props.timeslotId,
                locationId: props.locationId,
                body: valuesClone,
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="resourceTypeId"
                        options={Array.from(resourceTypeMap.keys())}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            required
                            label={strings.resourceType}
                            error={
                              touched.resourceTypeId &&
                              Boolean(errors.resourceTypeId)
                            }
                            helperText={
                              touched.resourceTypeId && errors.resourceTypeId
                            }
                          />
                        )}
                        onChange={(e, value: any) => {
                          console.log(value);
                          setFieldValue("resourceTypeId", value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="count"
                        name="count"
                        label={strings.count}
                        value={values.count}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.count && Boolean(errors.count)}
                        helperText={touched.count && errors.count}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.create}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
